
// @ts-nocheck


export const localeCodes =  [
  "en",
  "es",
  "fr"
]

export const localeLoaders = {
  en: [
    {
      key: "locale_en_46ts_1d30d761",
      load: () => import("#nuxt-i18n/1d30d761" /* webpackChunkName: "locale_en_46ts_1d30d761" */),
      cache: true
    }
  ],
  es: [
    {
      key: "locale_es_46ts_a641eb2b",
      load: () => import("#nuxt-i18n/a641eb2b" /* webpackChunkName: "locale_es_46ts_a641eb2b" */),
      cache: true
    }
  ],
  fr: [
    {
      key: "locale_fr_46ts_2fce4232",
      load: () => import("#nuxt-i18n/2fce4232" /* webpackChunkName: "locale_fr_46ts_2fce4232" */),
      cache: true
    }
  ]
}

export const vueI18nConfigs = [
  () => import("#nuxt-i18n/f3e70d3b" /* webpackChunkName: "config_i18n_46config_46ts_f3e70d3b" */)
]

export const nuxtI18nOptions = {
  restructureDir: false,
  experimental: {
    localeDetector: "",
    switchLocalePathLinkSSR: false,
    autoImportTranslationFunctions: false,
    typedPages: true,
    typedOptionsAndMessages: false,
    generatedLocaleFilePathFormat: "absolute",
    alternateLinkCanonicalQueries: false,
    hmr: true
  },
  bundle: {
    compositionOnly: true,
    runtimeOnly: false,
    fullInstall: true,
    dropMessageCompiler: false,
    optimizeTranslationDirective: false
  },
  compilation: {
    strictMessage: true,
    escapeHtml: false
  },
  customBlocks: {
    defaultSFCLang: "json",
    globalSFCScope: false
  },
  locales: [
    {
      code: "en",
      language: "en",
      files: [
        "/app/apps/web/locales/en.ts"
      ]
    },
    {
      code: "es",
      language: "es",
      files: [
        "/app/apps/web/locales/es.ts"
      ]
    },
    {
      code: "fr",
      language: "fr",
      files: [
        "/app/apps/web/locales/fr.ts"
      ]
    }
  ],
  defaultLocale: "en",
  defaultDirection: "ltr",
  routesNameSeparator: "___",
  trailingSlash: false,
  defaultLocaleRouteNameSuffix: "default",
  strategy: "prefix_except_default",
  lazy: true,
  langDir: "./locales/",
  rootRedirect: undefined,
  detectBrowserLanguage: {
    alwaysRedirect: false,
    cookieCrossOrigin: false,
    cookieDomain: null,
    cookieKey: "i18n_redirected",
    cookieSecure: false,
    fallbackLocale: "en",
    redirectOn: "root",
    useCookie: true
  },
  differentDomains: false,
  baseUrl: "https://www.thecompaniesapi.com",
  customRoutes: "page",
  pages: {},
  skipSettingLocaleOnNavigate: false,
  types: "composition",
  debug: false,
  parallelPlugin: false,
  multiDomainLocales: false,
  i18nModules: []
}

export const normalizedLocales = [
  {
    code: "en",
    language: "en",
    files: [
      {
        path: "/app/apps/web/locales/en.ts",
        cache: undefined
      }
    ]
  },
  {
    code: "es",
    language: "es",
    files: [
      {
        path: "/app/apps/web/locales/es.ts",
        cache: undefined
      }
    ]
  },
  {
    code: "fr",
    language: "fr",
    files: [
      {
        path: "/app/apps/web/locales/fr.ts",
        cache: undefined
      }
    ]
  }
]

export const NUXT_I18N_MODULE_ID = "@nuxtjs/i18n"
export const parallelPlugin = false
export const isSSG = false
export const hasPages = true

export const DEFAULT_COOKIE_KEY = "i18n_redirected"
export const DEFAULT_DYNAMIC_PARAMS_KEY = "nuxtI18nInternal"
export const SWITCH_LOCALE_PATH_LINK_IDENTIFIER = "nuxt-i18n-slp"
/** client **/

/** client-end **/